document.addEventListener('DOMContentLoaded', function() {
  // This javascript file is used to the calculation of the "Dimensionering af fedtudskiller" page.

  function calculateFedtudskiller() {
    // Input variables:
    let kogekar25 = document.querySelector('.custom-input-item.active input.kogekar25')?.value || 0;
    let kogekar50 = document.querySelector('.custom-input-item.active input.kogekar50')?.value || 0;
    let vippekar70 = document.querySelector('.custom-input-item.active input.vippekar70')?.value || 0;
    let vippekar100 = document.querySelector('.custom-input-item.active input.vippekar100')?.value || 0;
    let vaskVandlaas50 = document.querySelector('.custom-input-item.active input.vaskVandlaas50')?.value || 0;
    let opvaskemaskiner = document.querySelector('.custom-input-item.active input.opvaskemaskiner')?.value || 0;
    let industriopvasker = document.querySelector('.custom-input-item.active input.industriopvasker')?.value || 0;
    let industriopvaskerL = document.querySelector('.custom-input-item.active input.industriopvaskerL')?.value || 0;
    let vippestegepander = document.querySelector('.custom-input-item.active input.vippestegepander')?.value || 0;
    let fastestegepander = document.querySelector('.custom-input-item.active input.fastestegepander')?.value || 0;
    let hoejtryksrenser = document.querySelector('.custom-input-item.active input.hoejtryksrenser')?.value || 0;
    let skraber = document.querySelector('.custom-input-item.active input.skraber')?.value || 0;
    let groentsagsvasker = document.querySelector('.custom-input-item.active input.groentsagsvasker')?.value || 0;
    let gv50 = document.querySelector('.custom-input-item.active input.gv50')?.value || 0;
    let gv75 = document.querySelector('.custom-input-item.active input.gv75')?.value || 0;
    let gv100 = document.querySelector('.custom-input-item.active input.gv100')?.value || 0;

    // Amount table for variable calculation modifiers
    // Regular modifiers
    let regA0 = 0;
    let regA1 = 0.45;
    let regA2 = 0.31;
    let regA3 = 0.25;
    let regA4 = 0.21;
    let regA5 = 0.20;

    // Special modifiers
    let specA0 = 0;
    let specA1 = 0.60;
    let specA2 = 0.50;
    let specA3 = 0.40;
    let specA4 = 0.34;
    let specA5 = 0.30;

    // Kogekar Ø25mm
    let kogekar25Qi = 1;
    let kogekar25Output;
    kogekar25 = kogekar25 === '' ? 0 : kogekar25;
    kogekar25 = parseInt(kogekar25, 10) || 0;

    if (kogekar25 === 0) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA0;
    } else if (kogekar25 === 1) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA1;
    } else if (kogekar25 === 2) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA2;
    } else if (kogekar25 === 3) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA3;
    } else if (kogekar25 === 4) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA4;
    } else if (kogekar25 >= 5) {
      kogekar25Output = kogekar25 * kogekar25Qi * regA5;
    }

    kogekar25Output = Number(kogekar25Output.toFixed(3));

    // Kogekar Ø50mm
    let kogekar50Qi = 2;
    let kogekar50Output;
    kogekar50 = kogekar50 === '' ? 0 : kogekar50;
    kogekar50 = parseInt(kogekar50, 10) || 0;

    if (kogekar50 === 0) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA0;
    } else if (kogekar50 === 1) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA1;
    } else if (kogekar50 === 2) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA2;
    } else if (kogekar50 === 3) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA3;
    } else if (kogekar50 === 4) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA4;
    } else if (kogekar50 >= 5) {
      kogekar50Output = kogekar50 * kogekar50Qi * regA5;
    }

    kogekar50Output = Number(kogekar50Output.toFixed(3));

    // Vippekar Ø70mm
    let vippekar70Qi = 1;
    let vippekar70Output;
    vippekar70 = vippekar70 === '' ? 0 : vippekar70;
    vippekar70 = parseInt(vippekar70, 10) || 0;

    if (vippekar70 === 0) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA0;
    } else if (vippekar70 === 1) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA1;
    } else if (vippekar70 === 2) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA2;
    } else if (vippekar70 === 3) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA3;
    } else if (vippekar70 === 4) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA4;
    } else if (vippekar70 >= 5) {
      vippekar70Output = vippekar70 * vippekar70Qi * regA5;
    }

    vippekar70Output = Number(vippekar70Output.toFixed(3));

    // Vippekar Ø100mm
    let vippekar100Qi = 3;
    let vippekar100Output;
    vippekar100 = vippekar100 === '' ? 0 : vippekar100;
    vippekar100 = parseInt(vippekar100, 10) || 0;

    if (vippekar100 === 0) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA0;
    } else if (vippekar100 === 1) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA1;
    } else if (vippekar100 === 2) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA2;
    } else if (vippekar100 === 3) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA3;
    } else if (vippekar100 === 4) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA4;
    } else if (vippekar100 >= 5) {
      vippekar100Output = vippekar100 * vippekar100Qi * regA5;
    }

    vippekar100Output = Number(vippekar100Output.toFixed(3));

    // Vask med vandlås Ø50mm/ovn m. afløb
    let vask50Qi = 1.5;
    let vask50Output;
    vaskVandlaas50 = vaskVandlaas50 === '' ? 0 : vaskVandlaas50;
    vaskVandlaas50 = parseInt(vaskVandlaas50, 10) || 0;

    if (vaskVandlaas50 === 0) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA0;
    } else if (vaskVandlaas50 === 1) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA1;
    } else if (vaskVandlaas50 === 2) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA2;
    } else if (vaskVandlaas50 === 3) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA3;
    } else if (vaskVandlaas50 === 4) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA4;
    } else if (vaskVandlaas50 >= 5) {
      vask50Output = vaskVandlaas50 * vask50Qi * regA5;
    }

    vask50Output = Number(vask50Output.toFixed(3));

    // Opvaskemaskiner /2l/sek)
    let opvaskemaskinerQi = 2;
    let opvaskemaskinerOutput;
    opvaskemaskiner = opvaskemaskiner === '' ? 0 : opvaskemaskiner;
    opvaskemaskiner = parseInt(opvaskemaskiner, 10) || 0;

    if (opvaskemaskiner === 0) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA0;
    } else if (opvaskemaskiner === 1) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA1;
    } else if (opvaskemaskiner === 2) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA2;
    } else if (opvaskemaskiner === 3) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA3;
    } else if (opvaskemaskiner === 4) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA4;
    } else if (opvaskemaskiner >= 5) {
      opvaskemaskinerOutput = opvaskemaskiner * opvaskemaskinerQi * specA5;
    }

    opvaskemaskinerOutput = Number(opvaskemaskinerOutput.toFixed(3));

    // Industriopvaskemaskiner antal og l/sek
    let industriopvaskemaskinerQi = parseFloat(industriopvaskerL) ? Number(parseFloat(industriopvaskerL).toFixed(3)) : 0;
    let industriopvaskemaskinerOutput;
    industriopvasker = industriopvasker === '' ? 0 : industriopvasker;
    industriopvasker = parseInt(industriopvasker, 10) || 0;

    if (industriopvasker === 0) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA0;
    } else if (industriopvasker === 1) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA1;
    } else if (industriopvasker === 2) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA2;
    } else if (industriopvasker === 3) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA3;
    } else if (industriopvasker === 4) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA4;
    } else if (industriopvasker >= 5) {
      industriopvaskemaskinerOutput = industriopvasker * industriopvaskemaskinerQi * specA5;
    }

    industriopvaskemaskinerOutput = Number(industriopvaskemaskinerOutput.toFixed(3));

    // Vippestegepander
    let vippestegepanderQi = 1;
    let vippestegepanderOutput;
    vippestegepander = vippestegepander === '' ? 0 : vippestegepander;
    vippestegepander = parseInt(vippestegepander, 10) || 0;

    if (vippestegepander === 0) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA0;
    } else if (vippestegepander === 1) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA1;
    } else if (vippestegepander === 2) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA2;
    } else if (vippestegepander === 3) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA3;
    } else if (vippestegepander === 4) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA4;
    } else if (vippestegepander >= 5) {
      vippestegepanderOutput = vippestegepander * vippestegepanderQi * regA5;
    }

    vippestegepanderOutput = Number(vippestegepanderOutput.toFixed(3));

    // Faste stegepander
    let fasteStegepanderQi = 0.1;
    let fasteStegepanderOutput;
    fastestegepander = fastestegepander === '' ? 0 : fastestegepander;
    fastestegepander = parseInt(fastestegepander, 10) || 0;

    if (fastestegepander === 0) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA0;
    } else if (fastestegepander === 1) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA1;
    } else if (fastestegepander === 2) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA2;
    } else if (fastestegepander === 3) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA3;
    } else if (fastestegepander === 4) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA4;
    } else if (fastestegepander >= 5) {
      fasteStegepanderOutput = fastestegepander * fasteStegepanderQi * regA5;
    }

    fasteStegepanderOutput = Number(fasteStegepanderOutput.toFixed(3));

    // Højtryksrenser/damprenser
    let hoejtryksrenserQi = 2;
    let hoejtryksrenserOutput;
    hoejtryksrenser = hoejtryksrenser === '' ? 0 : hoejtryksrenser;
    hoejtryksrenser = parseInt(hoejtryksrenser, 10) || 0;

    if (hoejtryksrenser === 0) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA0;
    } else if (hoejtryksrenser === 1) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA1;
    } else if (hoejtryksrenser === 2) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA2;
    } else if (hoejtryksrenser === 3) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA3;
    } else if (hoejtryksrenser === 4) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA4;
    } else if (hoejtryksrenser >= 5) {
      hoejtryksrenserOutput = hoejtryksrenser * hoejtryksrenserQi * regA5;
    }

    hoejtryksrenserOutput = Number(hoejtryksrenserOutput.toFixed(3));

    // Skraber
    let skraberQi = 1.5;
    let skraberOutput;
    skraber = skraber === '' ? 0 : skraber;
    skraber = parseInt(skraber, 10) || 0;

    if (skraber === 0) {
      skraberOutput = skraber * skraberQi * regA0;
    } else if (skraber === 1) {
      skraberOutput = skraber * skraberQi * regA1;
    } else if (skraber === 2) {
      skraberOutput = skraber * skraberQi * regA2;
    } else if (skraber === 3) {
      skraberOutput = skraber * skraberQi * regA3;
    } else if (skraber === 4) {
      skraberOutput = skraber * skraberQi * regA4;
    } else if (skraber >= 5) {
      skraberOutput = skraber * skraberQi * regA5;
    }

    skraberOutput = Number(skraberOutput.toFixed(3));

    // Grøntsagsvasker
    let groentsagsvaskerQi = 2;
    let groentsagsvaskerOutput;
    groentsagsvasker = groentsagsvasker === '' ? 0 : groentsagsvasker;
    groentsagsvasker = parseInt(groentsagsvasker, 10) || 0;

    if (groentsagsvasker === 0) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA0;
    } else if (groentsagsvasker === 1) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA1;
    } else if (groentsagsvasker === 2) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA2;
    } else if (groentsagsvasker === 3) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA3;
    } else if (groentsagsvasker === 4) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA4;
    } else if (groentsagsvasker >= 5) {
      groentsagsvaskerOutput = groentsagsvasker * groentsagsvaskerQi * regA5;
    }

    groentsagsvaskerOutput = Number(groentsagsvaskerOutput.toFixed(3));

    // Gulvafløb 50mm
    let gulvafloeb50mmQi = 0.9;
    let gulvafloeb50mmOutput;
    gv50 = gv50 === '' ? 0 : gv50;
    gv50 = parseInt(gv50, 10) || 0;

    if (gv50 === 0) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA0;
    } else if (gv50 === 1) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA1;
    } else if (gv50 === 2) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA2;
    } else if (gv50 === 3) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA3;
    } else if (gv50 === 4) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA4;
    } else if (gv50 >= 5) {
      gulvafloeb50mmOutput = gv50 * gulvafloeb50mmQi * regA5;
    }

    gulvafloeb50mmOutput = Number(gulvafloeb50mmOutput.toFixed(3));

    // Gulvafløb 75mm
    let gulvafloeb75mmQi = 1.2;
    let gulvafloeb75mmOutput;
    gv75 = gv75 === '' ? 0 : gv75;
    gv75 = parseInt(gv75, 10) || 0;

    if (gv75 === 0) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA0;
    } else if (gv75 === 1) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA1;
    } else if (gv75 === 2) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA2;
    } else if (gv75 === 3) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA3;
    } else if (gv75 === 4) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA4;
    } else if (gv75 >= 5) {
      gulvafloeb75mmOutput = gv75 * gulvafloeb75mmQi * regA5;
    }

    gulvafloeb75mmOutput = Number(gulvafloeb75mmOutput.toFixed(3));

    // Gulvafløb 100mm
    let gulvafloeb100mmQi = 1.5;
    let gulvafloeb100mmOutput;
    gv100 = gv100 === '' ? 0 : gv100;
    gv100 = parseInt(gv100, 10) || 0;

    if (gv100 === 0) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA0;
    } else if (gv100 === 1) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA1;
    } else if (gv100 === 2) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA2;
    } else if (gv100 === 3) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA3;
    } else if (gv100 === 4) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA4;
    } else if (gv100 >= 5) {
      gulvafloeb100mmOutput = gv100 * gulvafloeb100mmQi * regA5;
    }

    gulvafloeb100mmOutput = Number(gulvafloeb100mmOutput.toFixed(3));

    // Total output calculation
    let qs = kogekar25Output + kogekar50Output + vippekar70Output + vippekar100Output +
                      vask50Output + opvaskemaskinerOutput + industriopvaskemaskinerOutput +
                      vippestegepanderOutput + fasteStegepanderOutput + hoejtryksrenserOutput +
                      skraberOutput + groentsagsvaskerOutput + gulvafloeb50mmOutput +
                      gulvafloeb75mmOutput + gulvafloeb100mmOutput;
    
    let Ft = parseFloat(document.querySelector('#tempfakt').value) || 0;
    let Fd = parseFloat(document.querySelector('#densitetsfakt').value) || 0;
    let Fr = parseFloat(document.querySelector('#rengfakt').value) || 0;
    let sandfangStr = document.querySelector('#sandfangstr').value || 0;

    let qud = qs * Ft * Fd * Fr;


    // Defining output variables
    let outputOne = document.querySelector('#total-output-one');
    let outputTwo = document.querySelector('#total-output-two');
    let outputThree = document.querySelector('#total-output-three');


    // Showing output calculations
    if (outputOne) {
      outputOne.textContent = qud.toFixed(2) + ' L/s';
    }
    let qudNS;
    if (outputTwo) {
      if (qud > 0 && qud <= 2) {
        qudNS = '2';
      } else if (qud > 2 && qud <= 4) {
        qudNS = '4';
      } else if (qud > 4 && qud <= 7) {
        qudNS = '7';
      } else if (qud > 7 && qud <= 10) {
        qudNS = '10';
      } else if (qud > 10 && qud <= 15) {
        qudNS = '15';
      } else if (qud > 15 && qud <= 20) {
        qudNS = '20';
      } else if (qud > 20 && qud <= 25) {
        qudNS = '25';
      } else if (qud > 25 && qud <= 30) {
        qudNS = '30';
      } else if (qud > 30 && qud <= 40) {
        qudNS = '40';
      } else if (qud > 40) {
        qudNS = 'Speciallavet';
      }
      outputTwo.textContent = qudNS;
    }
    if (outputThree) {
      let qudSF = Number(qudNS) * Number(sandfangStr);
      outputThree.textContent = qudSF + ' L';
    }

    // Product recommendation from calculation
    let products = document.querySelectorAll('.product-recommendation-item');
    let fallbackProduct = document.querySelector('.no-product-recommendation-item');

    let bestProduct = null;
    let bestInterval = Infinity; // Start with Infinity since we want the lowest intervalValue above qud

    console.log('qud:', qud);

    products.forEach(function(product, idx) {
      product.classList.forEach(function(className) {
        let match = className.match(/^interval-(\d+)$/);
        if (match) {
          let intervalValue = parseInt(match[1], 10);
          console.log(`Product #${idx} class: ${className}, intervalValue: ${intervalValue}`);
          if (intervalValue >= qud && intervalValue < bestInterval) {
            bestInterval = intervalValue;
            bestProduct = product;
            console.log(`--> New bestProduct found: Product #${idx} with intervalValue ${intervalValue}`);
          }
        }
      });
    });

    console.log('Best interval found:', bestInterval);
    console.log('Best product:', bestProduct);

    // Hide all products first using the 'hidden' class
    products.forEach(function(product) {
      product.classList.add('hidden');
      product.classList.remove('chosen');
    });
    if (fallbackProduct) {
      fallbackProduct.classList.add('hidden');
      fallbackProduct.classList.remove('chosen');
    }

    // Show the best matching product, or fallback if none found
    if (bestProduct) {
      console.log('Showing bestProduct');
      bestProduct.classList.remove('hidden');
      bestProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    } else if (fallbackProduct) {
      console.log('Showing fallbackProduct');
      fallbackProduct.classList.remove('hidden');
      fallbackProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    }

  }

  let submitButton = document.querySelector('#submit-calculation-fedt');
  if (submitButton) {
    submitButton.addEventListener('click', function(event) {
      event.preventDefault();
      calculateFedtudskiller();
    });
  }

  // Custom input selector logic
  // Helper: Get all selected option data-ids
  function getAllSelectedIds() {
    return Array.from(document.querySelectorAll('.custom-dropdown-selected[data-selected-id]'))
      .map(sel => sel.getAttribute('data-selected-id'))
      .filter(Boolean);
  }

  // Helper: Update all dropdowns to mark used options
  function updateDropdownOptions() {
    const usedIds = getAllSelectedIds();
    document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      dropdown.querySelectorAll('.custom-option').forEach(option => {
        if (
          usedIds.includes(option.dataset.id) &&
          dropdown.querySelector('.custom-dropdown-selected').getAttribute('data-selected-id') !== option.dataset.id
        ) {
          option.classList.add('used');
        } else {
          option.classList.remove('used');
        }
      });
    });
  }

  // Initialize a dropdown (attach events)
  function initDropdown(dropdown) {
    const selected = dropdown.querySelector('.custom-dropdown-selected');
    const options = dropdown.querySelector('.custom-dropdown-options');
    const optionSpans = options.querySelectorAll('.custom-option');
    const row = dropdown.closest('.custom-input-selector-row');
    const inputsList = row.querySelector('.custom-inputs-list');
    const inputItems = inputsList.querySelectorAll('.custom-input-item');

    // Open/close
    selected.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    // Option click
    optionSpans.forEach(function(option) {
      option.addEventListener('click', function(e) {
        if (option.classList.contains('used')) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        e.stopPropagation();
        // Set selected text and data
        selected.textContent = option.textContent;
        selected.setAttribute('data-selected-id', option.dataset.id);
        optionSpans.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
        dropdown.classList.remove('open');
        // Show only the matching input, reset others to 0
        inputItems.forEach(item => {
          if (item.dataset.id === option.dataset.id) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
            // Reset input value to 0 when hidden
            const input = item.querySelector('input');
            if (input) input.value = '0';
          }
        });
        updateDropdownOptions();
      });
    });

    // Allow clearing selection by double-clicking selected
    selected.addEventListener('dblclick', function(e) {
      e.stopPropagation();
      selected.textContent = 'Vælg enhed...';
      selected.removeAttribute('data-selected-id');
      optionSpans.forEach(opt => opt.classList.remove('active'));
      inputItems.forEach(item => {
        item.classList.remove('active');
        // Reset input value to 0 when deselected
        const input = item.querySelector('input');
        if (input) input.value = '0';
      });
      updateDropdownOptions();
    });
  }

  // Only one document click handler!
  document.addEventListener('click', function(e) {
    // If the click is on a used option, do nothing and keep dropdown open
    if (
      e.target.classList &&
      e.target.classList.contains('custom-option') &&
      e.target.classList.contains('used')
    ) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    // Otherwise, close all dropdowns
    document.querySelectorAll('.custom-dropdown.open').forEach(function(dropdown) {
      dropdown.classList.remove('open');
    });
  });

  // Initialize all dropdowns on page load
  document.querySelectorAll('.custom-dropdown').forEach(initDropdown);

  // Add new dropdown on button click
  const addButton = document.getElementById('add-custom-input-selector');
  if (addButton) {
    addButton.addEventListener('click', function() {
      const firstRow = document.querySelector('.custom-input-selector-row');
      if (!firstRow) return;
      const newRow = firstRow.cloneNode(true);
      // Reset selection in new row
      const selected = newRow.querySelector('.custom-dropdown-selected');
      if (selected) {
        selected.textContent = 'Vælg enhed...';
        selected.removeAttribute('data-selected-id');
      }
      newRow.querySelectorAll('.custom-option').forEach(opt => {
        opt.classList.remove('active', 'used');
      });
      newRow.querySelectorAll('.custom-input-item').forEach(item => {
        item.classList.remove('active');
        // Optionally clear input values:
        const input = item.querySelector('input');
        if (input) input.value = '';
      });
      // Attach events
      const dropdown = newRow.querySelector('.custom-dropdown');
      if (dropdown) initDropdown(dropdown);
      // Insert before the add button
      const group = document.getElementById('custom-input-selector-group');
      if (group) group.insertBefore(newRow, addButton);
      updateDropdownOptions();
    });
  }

  // Initial update
  updateDropdownOptions();


});